import { IonIcon } from "@ionic/react";
import Line from "../../components/debrief/tournamentView/Line";
import { caretForwardOutline } from "ionicons/icons";

export const TBD = "TBD";

export function getNumberOfMatchesBottomBracket(totalRounds) {
  return Math.round(Math.round(Math.pow(2, totalRounds - 1)) / 2);
}

export function getNumberOfLanes(totalRounds) {
  return Math.round(totalRounds * 2) - 1;
}

export function getFontStyle(
  fontSize,
  boxW,
  boxH,
  forNightMode,
  bold = false,
  won = false
) {
  let fontStyle = {
    position: "absolute",
    width: "fit-content",
    top: boxH / 2 - fontSize / 2,
    left: boxW / 2,
    fontSize: fontSize.toString(10) + "px",
    transform: "translate(-50%, -50%)",
    fontWeight: bold ? "800" : "500",
    textAlign: "center",
    color: "#010101",
    backgroundColor: "transparent",
  };
  if (forNightMode) {
    fontStyle.color = "#c2c4c2";
  }
  if (won) {
    fontStyle.backgroundColor = forNightMode ? "#485138" : "#b5ca8d";
  }
  return fontStyle;
}

export function isThisLaneLeftSide(laneNumber, numberOfLanes) {
  return laneNumber < Math.round(numberOfLanes / 2);
}

export function numberOfMatchesForLane(
  laneNumber,
  totalRounds,
  numberOfMatchesBottomBracket,
  numberOfLanes
) {
  // Note: numberOfMatchesBottomBracket is HALF because of
  // two pyramids

  // is this the center ?
  if ((numberOfLanes + 1) / 2 === laneNumber) {
    return 1;
  }
  const isLeftSide = isThisLaneLeftSide(laneNumber, numberOfLanes);
  const pseudoLane = getPseudoLaneNumber(isLeftSide, laneNumber, totalRounds);
  return numberOfMatchesBottomBracket * Math.pow(2, -(pseudoLane - 1));
}

export function getPseudoLaneNumber(isLeftSide, laneNumber, totalRounds) {
  if (totalRounds % 2 === 0 && (totalRounds + 1) / 2 === laneNumber) {
    return laneNumber;
  } else {
    return isLeftSide ? laneNumber : Math.round(totalRounds * 2) - laneNumber;
  }
}

export function getPseudoMatchNumber(
  isLeftSide,
  index,
  numberOfMatchesInLane,
  numberOfMatchesInRound,
  numberOfRoundsIsOdd
) {
  if (isLeftSide) {
    return index;
  }
  if (numberOfMatchesInRound === 1) {
    return 0;
  }
  const realTotalMatchesForRound = numberOfMatchesInLane * 2;
  return realTotalMatchesForRound - index - 1;
}

export function getCellSizeForLane(sizes, numMatchesForLane) {
  return {
    h: Math.round(sizes.laneH / numMatchesForLane),
    w: sizes.laneW,
  };
}

export function getCellPosition(cellSize, row, lane, xOffset = 0, yOffset = 0) {
  const zeroLane = lane - 1;
  return {
    x: zeroLane * cellSize.w + xOffset,
    y: row * cellSize.h + yOffset,
  };
}

export function getCenteredObjectPosition(cellPos, cellSize, objectW, objectH) {
  return {
    x: cellPos.x + cellSize.w / 2 - objectW / 2,
    y: cellPos.y + cellSize.h / 2 - objectH / 2,
  };
}

export function getEnterAndExitPointsOfMatch(
  originX,
  originY,
  sizes,
  isLeftSide
) {
  if (isLeftSide) {
    return {
      topEnterX: originX,
      topEnterY: originY + sizes.storyBoxH / 2 + sizes.smallPadding,
      bottomEnterX: originX,
      bottomEnterY:
        originY + sizes.matchBoxH - sizes.storyBoxH / 2 - sizes.smallPadding,
      exitX: originX + sizes.matchBoxW,
      exitY:
        originY +
        sizes.storyBoxH +
        sizes.smallPadding * 3 +
        sizes.versusBoxH / 2,
    };
  } else {
    return {
      topEnterX: originX + sizes.matchBoxW,
      topEnterY: originY + sizes.storyBoxH / 2 + sizes.smallPadding,
      bottomEnterX: originX + sizes.matchBoxW,
      bottomEnterY:
        originY + sizes.matchBoxH - sizes.storyBoxH / 2 - sizes.smallPadding,
      exitX: originX,
      exitY:
        originY +
        sizes.storyBoxH +
        sizes.smallPadding * 3 +
        sizes.versusBoxH / 2,
    };
  }
}

export function truncateTitle(text, zoomLevel) {
  // TODO: make this contigent on levels
  if (!text) {
    return "";
  }
  let maxChar = 35;
  if (zoomLevel === 1) {
    maxChar = 35;
  }
  // TODO: make this contigent on levels
  return text.slice(0, maxChar) + (text.length > maxChar ? "..." : "");
}

export function getPositionOfStoriesInMatchBox(
  matchPos,
  storyHeight,
  versusHeight,
  padding
) {
  const topY = matchPos.y + padding;
  const versusY = topY + storyHeight + padding;
  const bottomY = versusY + versusHeight + padding;
  const x = matchPos.x + padding;
  return {
    topX: x,
    topY,
    versusX: x,
    versusY,
    bottomX: x,
    bottomY,
  };
}

export function hasNaN(obj) {
  let hasNan = false;
  for (const [key, value] of Object.entries(obj)) {
    if (isNaN(value) && typeof value === "number") {
      console.log(`Property '${key}' is NaN`);
      hasNan = true;
    }
  }
  return hasNan;
}

// Helper to render a chevron arrow icon at (x, y) pointing in a direction
export function getArrowIcon(x, y, direction, nightMode, key, sizes) {
  // direction: "up", "down", "left", "right"
  let rotation = "rotate(0deg)";
  if (direction === "up") rotation = "rotate(-90deg)";
  else if (direction === "down") rotation = "rotate(90deg)";
  else if (direction === "left") rotation = "rotate(180deg)";
  // right is default (0deg)
  const arrowSize = sizes.arrowSize;
  const arrowOffset = Math.round(arrowSize / 2);
  return (
    <IonIcon
      key={key}
      icon={caretForwardOutline}
      style={{
        position: "absolute",
        left: x - arrowOffset, // 16px icon, center on tip
        top: y - arrowOffset,
        fontSize: arrowSize.toString() + "px",
        color: nightMode ? "#c2c4c2" : "#010101",
        transform: rotation,
        pointerEvents: "none",
        zIndex: 1,
      }}
    />
  );
}

// Helper to get offset for the back of the arrow
function getArrowOffset(direction, length) {
  // Returns [dx, dy] to move the icon so the back is at the given point
  const offset = length / 2;
  if (direction === "up") return [0, -offset];
  if (direction === "down") return [0, offset];
  if (direction === "left") return [-offset + 1, -1];
  if (direction === "right") return [offset - 1, 1];
  return [0, 0];
}

export function createLinesToNextMatch(
  matchPosA,
  matchPosB,
  sizes,
  payload,
  isLeftSide,
  toTop,
  nightMode
) {
  const enterExitPointsA = getEnterAndExitPointsOfMatch(
    matchPosA.x,
    matchPosA.y,
    sizes,
    isLeftSide
  );
  const enterExitPointsB = getEnterAndExitPointsOfMatch(
    matchPosB.x,
    matchPosB.y,
    sizes,
    isLeftSide
  );

  // Exit Line
  const exitLineDirection = isLeftSide ? "right" : "left";
  payload.push(
    <Line
      key={
        "exit_" +
        enterExitPointsA.exitX.toString() +
        "_" +
        enterExitPointsA.exitY.toString() +
        "_" +
        (enterExitPointsA.exitX + sizes.normalSpace).toString() +
        "_" +
        enterExitPointsA.exitX.toString()
      }
      pointA={{ x: enterExitPointsA.exitX, y: enterExitPointsA.exitY }}
      pointB={{
        x:
          enterExitPointsA.exitX +
          (isLeftSide ? sizes.normalSpace : -sizes.normalSpace),
        y: enterExitPointsA.exitY,
      }}
      nightMode={nightMode}
      lineWidth={sizes.lineWidth}
    />
  );
  // Add arrow at the start of the exit line (back at start)
  {
    const [dx, dy] = getArrowOffset(exitLineDirection, sizes.arrowSize / 2);
    payload.push(
      getArrowIcon(
        enterExitPointsA.exitX + dx,
        enterExitPointsA.exitY + dy,
        exitLineDirection,
        nightMode,
        `arrowicon_exit_start_${enterExitPointsA.exitX}_${enterExitPointsA.exitY}`,
        sizes
      )
    );
  }

  // Enter Line
  const enterLineDirection = isLeftSide ? "right" : "left";
  payload.push(
    <Line
      key={
        "enter_" +
        (
          (toTop ? enterExitPointsB.topEnterX : enterExitPointsB.bottomEnterX) -
          sizes.normalSpace
        ).toString() +
        "_" +
        (toTop
          ? enterExitPointsB.topEnterY
          : enterExitPointsB.bottomEnterY
        ).toString() +
        "_" +
        (toTop
          ? enterExitPointsB.topEnterY
          : enterExitPointsB.bottomEnterY
        ).toString() +
        "_" +
        (toTop
          ? enterExitPointsB.topEnterY
          : enterExitPointsB.bottomEnterY
        ).toString()
      }
      pointA={{
        x:
          (toTop ? enterExitPointsB.topEnterX : enterExitPointsB.bottomEnterX) -
          (isLeftSide ? sizes.normalSpace : -sizes.normalSpace),
        y: toTop ? enterExitPointsB.topEnterY : enterExitPointsB.bottomEnterY,
      }}
      pointB={{
        x: toTop ? enterExitPointsB.topEnterX : enterExitPointsB.topEnterX,
        y: toTop ? enterExitPointsB.topEnterY : enterExitPointsB.bottomEnterY,
      }}
      nightMode={nightMode}
      lineWidth={sizes.lineWidth}
    />
  );
  // Add arrow at the end of the enter line (tip at end)
  {
    const [dx, dy] = getArrowOffset(enterLineDirection, sizes.arrowSize / 2);
    payload.push(
      getArrowIcon(
        (toTop ? enterExitPointsB.topEnterX : enterExitPointsB.topEnterX) - dx,
        (toTop ? enterExitPointsB.topEnterY : enterExitPointsB.bottomEnterY) +
          dy,
        enterLineDirection,
        nightMode,
        `arrowicon_enter_${
          toTop ? enterExitPointsB.topEnterX : enterExitPointsB.topEnterX
        }_${
          toTop ? enterExitPointsB.topEnterY : enterExitPointsB.bottomEnterY
        }`,
        sizes
      )
    );
  }

  // Connector Line -- exit to enter
  const connectorStartX =
    enterExitPointsA.exitX +
    (isLeftSide ? sizes.normalSpace : -sizes.normalSpace);
  const connectorStartY = enterExitPointsA.exitY;
  const connectorEndX =
    (toTop ? enterExitPointsB.topEnterX : enterExitPointsB.bottomEnterX) -
    (isLeftSide ? sizes.normalSpace : -sizes.normalSpace);
  const connectorEndY = toTop
    ? enterExitPointsB.topEnterY
    : enterExitPointsB.bottomEnterY;

  const lineLength = Math.sqrt(
    Math.pow(connectorEndX - connectorStartX, 2) +
      Math.pow(connectorEndY - connectorStartY, 2)
  );

  payload.push(
    <Line
      key={
        "connector_" +
        connectorStartX.toString() +
        "_" +
        connectorStartY.toString() +
        "_" +
        connectorEndX.toString() +
        "_" +
        connectorEndY.toString()
      }
      pointA={{
        x: connectorStartX,
        y: connectorStartY,
      }}
      pointB={{
        x: connectorEndX,
        y: connectorEndY,
      }}
      nightMode={nightMode}
      lineWidth={sizes.lineWidth}
    />
  );

  // Add directional arrows if line is long enough
  if (lineLength > sizes.normalSpace) {
    const arrowSpacing = sizes.normalSpace * 4; // Space between arrows
    const numArrows = Math.floor(lineLength / arrowSpacing);

    for (let i = 1; i <= numArrows; i++) {
      const t = (i * arrowSpacing) / lineLength; // Position along the line (0 to 1)
      const isPointingUp = connectorEndY < connectorStartY;
      const arrowX = connectorEndX + (isPointingUp ? 1 : -1);
      const arrowY = connectorStartY + (connectorEndY - connectorStartY) * t;
      const direction = isPointingUp ? "up" : "down";
      // Only render if not too close to the end
      const distToEnd = Math.abs(arrowY - connectorEndY);
      if (distToEnd < sizes.arrowSize) continue;
      payload.push(
        getArrowIcon(
          arrowX,
          arrowY,
          direction,
          nightMode,
          `arrowicon_${arrowX}_${arrowY}_${i}`,
          sizes
        )
      );
    }
  }
}

export function isFinalistLane(lane, totalLanes) {
  return lane === Math.ceil(totalLanes / 2);
}

export function getLaneBackgroundColor({ lane, totalLanes, sizes, nightMode }) {
  const isLaneOnLeft = isThisLaneLeftSide(lane, totalLanes);
  const pseudoLane = getPseudoLaneNumber(isLaneOnLeft, lane, sizes.totalRounds);

  // Finalist lane: yellow
  const alpha = 0.18;
  if (isFinalistLane(lane, totalLanes)) {
    return "rgba(248,220,85," + alpha.toString() + ")"; // #f8dc55
  }

  // Alternate blue and purple for other lanes
  const blue = [42, 110, 140]; // #2a6e8c
  const purple = [111, 71, 118]; // #6F4776
  // Odd pseudoLane: blue, Even pseudoLane: purple
  const color = pseudoLane % 2 === 1 ? blue : purple;
  return `rgba(${color[0]},${color[1]},${color[2]},${alpha})`;
}

export function getSizesForZoomLevel(level, totalRounds) {
  // Zoom levels: 1 = most zoomed in (default), 2 = medium, 3 = more zoomed out, 4 = most zoomed out
  let matchBoxW,
    matchBoxH,
    normalSpace,
    smallPadding,
    smallFontSize,
    normalFontSize,
    largeFontSize,
    headerHeight,
    trophyHeight,
    arrowSize,
    lineWidth;

  if (level === 1) {
    // Most zoomed in (current default)
    matchBoxW = 400;
    matchBoxH = 200;
    normalSpace = 50;
    smallPadding = 10;
    smallFontSize = 14;
    normalFontSize = 16;
    largeFontSize = 20;
    headerHeight = 75;
    trophyHeight = 30;
    arrowSize = 16;
    lineWidth = 2;
  } else if (level === 2) {
    // Medium zoom
    matchBoxW = 300;
    matchBoxH = 150;
    normalSpace = 40;
    smallPadding = 8;
    smallFontSize = 10;
    normalFontSize = 12;
    largeFontSize = 16;
    headerHeight = 60;
    trophyHeight = 25;
    arrowSize = 16;
    lineWidth = 2;
  } else if (level === 3) {
    // More zoomed out
    matchBoxW = 200;
    matchBoxH = 100;
    normalSpace = 30;
    smallPadding = 6;
    smallFontSize = 7;
    normalFontSize = 8;
    largeFontSize = 12;
    headerHeight = 45;
    trophyHeight = 20;
    arrowSize = 16;
    lineWidth = 1;
  } else if (level === 4) {
    // Most zoomed out
    matchBoxW = 120;
    matchBoxH = 60;
    normalSpace = 18;
    smallPadding = 4;
    smallFontSize = 4;
    normalFontSize = 5;
    largeFontSize = 7;
    headerHeight = 28;
    trophyHeight = 12;
    arrowSize = 10;
    lineWidth = 1;
  } else {
    // Default to level 1
    matchBoxW = 400;
    matchBoxH = 200;
    normalSpace = 50;
    smallPadding = 10;
    smallFontSize = 14;
    normalFontSize = 16;
    largeFontSize = 20;
    headerHeight = 75;
    trophyHeight = 30;
    arrowSize = 16;
    lineWidth = 2;
  }

  let laneW = matchBoxW + Math.floor(normalSpace * 2);
  const numberOfMatchesBottomBracket =
    getNumberOfMatchesBottomBracket(totalRounds);
  let laneH = Math.ceil(
    (matchBoxH + normalSpace) * numberOfMatchesBottomBracket
  );

  let numberOfLanes = getNumberOfLanes(totalRounds);
  let screenSizeW = laneW * numberOfLanes;
  let screenSizeH = laneH;
  let storyBoxH = Math.floor(matchBoxH * 0.4) - smallPadding * 2;
  let storyBoxW = matchBoxW - smallPadding * 2;
  let versusBoxH = Math.floor(matchBoxH * 0.2);

  let storyCellW = Math.floor(storyBoxW * 0.2);

  let flagW = Math.floor(matchBoxW * 0.1); // Scale flag size with zoom level

  // Add prettiness variables based on zoom level
  let matchBoxRadius, matchBoxShadow, storyBoxRadius, storyBoxShadow;
  if (level === 1) {
    matchBoxRadius = "22px";
    matchBoxShadow = "0 4px 24px 0 rgba(0,0,0,0.16)";
    storyBoxRadius = "16px";
    storyBoxShadow = "0 2px 8px 0 rgba(0,0,0,0.10)";
  } else if (level === 2) {
    matchBoxRadius = "16px";
    matchBoxShadow = "0 2px 12px 0 rgba(0,0,0,0.13)";
    storyBoxRadius = "12px";
    storyBoxShadow = "0 1px 4px 0 rgba(0,0,0,0.08)";
  } else if (level === 3) {
    matchBoxRadius = "10px";
    matchBoxShadow = "0 1px 4px 0 rgba(0,0,0,0.10)";
    storyBoxRadius = "8px";
    storyBoxShadow = "0 1px 2px 0 rgba(0,0,0,0.06)";
  } else if (level === 4) {
    matchBoxRadius = "6px";
    matchBoxShadow = "0 1px 4px 0 rgba(0,0,0,0.10)";
    storyBoxRadius = "5px";
    storyBoxShadow = "0 1px 2px 0 rgba(0,0,0,0.06)";
  } else {
    matchBoxRadius = "22px";
    matchBoxShadow = "0 4px 24px 0 rgba(0,0,0,0.16)";
    storyBoxRadius = "16px";
    storyBoxShadow = "0 2px 8px 0 rgba(0,0,0,0.10)";
  }

  return {
    matchBoxW,
    matchBoxH,
    normalSpace,
    laneW,
    laneH,
    totalRounds,
    numberOfLanes,
    screenSizeW,
    screenSizeH,
    smallPadding,
    storyBoxW,
    storyBoxH,
    versusBoxH,
    storyCellW,
    smallFontSize,
    normalFontSize,
    largeFontSize,
    numberOfMatchesBottomBracket,
    flagW,
    headerHeight,
    trophyHeight,
    arrowSize,
    lineWidth,
    matchBoxRadius,
    matchBoxShadow,
    storyBoxRadius,
    storyBoxShadow,
  };
}
